import { render } from "./WrapFooter.vue?vue&type=template&id=5ca81052&scoped=true"
import script from "./WrapFooter.vue?vue&type=script&lang=js"
export * from "./WrapFooter.vue?vue&type=script&lang=js"

import "./WrapFooter.vue?vue&type=style&index=0&id=5ca81052&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca81052"]])

export default __exports__